import { useAtsCandidateDiscoveryApi } from '@/composables/useApi';

export class SkippedProsPersistence {
  async skipPro(proProfileId: number): Promise<void> {
    const url = `/search-talent/skipped-pros/${proProfileId}`;
    const { error } = await useAtsCandidateDiscoveryApi(url).put();

    if (error.value) {
      throw new Error(error.value);
    }
  }

  async restorePro(proProfileId: number): Promise<void> {
    const url = `/search-talent/skipped-pros/${proProfileId}`;
    const { error } = await useAtsCandidateDiscoveryApi(url).delete();

    if (error.value) {
      throw new Error(error.value);
    }
  }
}
